<template>
	<div class="container">
		<section class="catalog">
			<div class="row">
				<div class="col-sm-3">
					<filter></filter>
					<subcategories></subcategories>
					<color></color>
				</div>
				<div class="col-sm-9">
					<h2 class="no-margin category-title">Sillas</h2>
					<div class="row catalog-cards">
			            <div class="col-xs-12 col-sm-6 col-md-4" v-for="product in render_products | filter min max sub color | paginate $route.query.page per_page">
			              <cards :product="product"></cards>
			            </div>
			        </div>
					<div class="empty text-general category-title" v-if="render_products | filter min max sub color | length">
						<div v-if="loading" class="loading-products">Cargando Productos<loader class="loader"></loader></div>
						<div v-else>No hay productos en esta categoría o subcategoría.</div>
					</div>
				</div>
				<pagination :url="url" :items="products | filter min max sub color" :per_page="per_page"></pagination>
			</div>
		</section>
	</div>
</template>

<style scoped>
	.no-top {
		margin-top: 0;
		padding-top: 0;
	}
	.col-sm-3 {
		margin-bottom: 30px;
	}
</style>

<script>
import Loader from '../../components/Loader.vue';
import Cards from '../../components/Home/Card.vue';
import Filter from '../../components/Product/Filter.vue';
import Subcategories from '../../components/Product/Subcategories.vue';
import Color from '../../components/Product/Color.vue';
import Store from '../../store/store';
import Pagination from '../../components/Pagination.vue';
import { router } from '../../routes/routes';
import { getColors, resetColors } from '../../store/actions';

export default {
	data () {
		return {
			url: '/sillas?page=',
			per_page: 30,
			first: true
		}
	},

	vuex: {
		getters: {
			min: state => state.min_price,
			max: state => state.max_price,
			sub: state => state.sub_id,
			color: state => state.color,
			loading: state => state.loading_products,
			products: state => {
				return state.products.filter(p => {
					if (p.category.parents) {
						return p.category.parents.id == 6 && !p.parent_id;
					}

					return p.category.id == 6 && !p.parent_id;
				});
			}
		},
		actions: {
			getColors,
			resetColors
		}
	},

	computed:  {
		render_products() {
			return this.products;
		}
	},

	components: {
		Cards,
		Filter,
		Subcategories,
		Color,
		Pagination,
		Loader
	},

	// methods: {
	// 	fixRibbon () {
	// 		$(".item-card-new").css({"top": "0", "right": "25px"});
	// 	}
	// },

	ready () {
		if (!this.$route.query.color) {
			this.resetColors();
			this.getColors(6);
		}

		// Write the headers.
		document.title = 'Lasddi | Sillas de Diseño Escandinavo en México | Réplicas Eames'
		$('meta[name="description"]').attr('content', 'En Lasddi encuentra sillas réplicas de diseño estilo escandinavo, para tu espacio, comedor, bar, oficina, exteriores, etc.')
	}
}
</script>



// WEBPACK FOOTER //
// Sillas.vue?2db9263e